// extracted by mini-css-extract-plugin
export var externalLink = "_6f-0";
export var internalLinkLabel = "_6f-1";